


























































import { computed, defineComponent, watch } from '@vue/composition-api';
import { useConfirmDialog } from '@vueuse/core';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { useAdminAccess } from '@front-app/modules/group/hooks/useAdminAccess';
import { Routes } from '@front-app/constants/routes';
import { useDigestsStore } from '@front-app/modules/digests/store/GroupDigests';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import CreateDigestCtaCard from '@front-app/modules/digests/components/CreateDigestCtaCard.vue';
import DigestPreviewCard from '@front-app/modules/digests/components/DigestPreviewCard.vue';
import EditDigestPanel from '@front-app/modules/digests/components/EditDigestPanel.vue';
import CreateDigestPanel from '@front-app/modules/digests/components/CreateDigestPanel.vue';
import { DigestQueryParam } from '@front-app/modules/digests/routing/params';
import { setInQuerySingle } from '@front-app/util/routing';

export default defineComponent({
	components: {
		ErrorCard,
		ColumnContainer,
		ColumnHeader,
		LoaderState,
		CreateDigestCtaCard,
		DigestPreviewCard,
		EditDigestPanel,
		CreateDigestPanel,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		digestIdToEdit: {
			type: String,
			default: '',
		},
	},
	setup(props, ctx) {
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));
		const { hasDigestManagementAccess } = useAdminAccess(group);

		// Status and fetching data
		const {
			isLoading: isLoadingDigests,
			isError: hasErrorLoadingDigests,
			track,
		} = useAsyncStatus();
		watch(() => props.groupId, (curr) => {
			if (!curr) {
				return;
			}
			track(useDigestsStore().fetchDigestsForGroup(props.groupId));
		}, { immediate: true });

		const digests = computed(() => useDigestsStore().groupDigests(props.groupId));

		// Navigation for edits
		const selectDigestToEdit = (digestId: string) => {
			ctx.root.$router.push(setInQuerySingle(ctx.root.$router, ctx.root.$route, DigestQueryParam.EDIT, digestId));
		};
		const clearDigestToEdit = () => selectDigestToEdit('');

		// Create
		const createDialog = useConfirmDialog();

		return {
			// Status
			isLoadingDigests,
			hasErrorLoadingDigests,
			// Main data
			digests,
			// Navigation for edits
			selectDigestToEdit,
			clearDigestToEdit,
			// Create digest panel
			createDialog,
			// Util
			GROUP_MAIN_ROUTE: Routes.GROUP_MAIN,
			hasDigestManagementAccess,
		};
	},
});
